/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Webhook_Token_RegeneratedInputs */

const cs_toast_webhook_token_regenerated = /** @type {(inputs: Toast_Webhook_Token_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook token byl obnoven`)
};

const en_toast_webhook_token_regenerated = /** @type {(inputs: Toast_Webhook_Token_RegeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook token regenerated`)
};

/**
* | output |
* | --- |
* | "Webhook token regenerated" |
*
* @param {Toast_Webhook_Token_RegeneratedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_webhook_token_regenerated = /** @type {((inputs?: Toast_Webhook_Token_RegeneratedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Webhook_Token_RegeneratedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_webhook_token_regenerated(inputs)
	return cs_toast_webhook_token_regenerated(inputs)
});